// AES-256-GCM Client-Side File Encryption

export async function encryptFile(fileArrayBuffer) {
  const key = await crypto.subtle.generateKey(
    { name: 'AES-GCM', length: 256 },
    true,
    ['encrypt', 'decrypt']
  );

  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encrypted = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    fileArrayBuffer
  );

  const exportedKey = await crypto.subtle.exportKey('raw', key);

  // Pack key + IV as JSON string for storage
  const encryptionData = JSON.stringify({
    key: Array.from(new Uint8Array(exportedKey)),
    iv: Array.from(iv),
  });

  return {
    encryptedData: new Uint8Array(encrypted),
    encryptionData,
  };
}

export async function decryptFile(encryptedArrayBuffer, encryptionDataStr) {
  const { key: keyArr, iv: ivArr } = JSON.parse(encryptionDataStr);

  const key = await crypto.subtle.importKey(
    'raw',
    new Uint8Array(keyArr),
    { name: 'AES-GCM', length: 256 },
    false,
    ['decrypt']
  );

  const iv = new Uint8Array(ivArr);

  const decrypted = await crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    encryptedArrayBuffer
  );

  return new Uint8Array(decrypted);
}
